import { useEffect } from "react";
import { useWidgetStore } from "../../store/widget-store";
import { getOrCreateVisitorId, getWidgetKey } from "../../lib/widget-key";
import { useRealtime } from "../../hooks/useRealtime";
import { MessageList } from "./MessageList";
import { MessageInput } from "./MessageInput";

export function ChatTab() {
  const loadMessages = useWidgetStore((state) => state.loadMessages);
  const visitorId = getOrCreateVisitorId();
  const publicKey = getWidgetKey();

  useEffect(() => {
    if (!publicKey) return;
    void loadMessages(publicKey, visitorId);
  }, [publicKey, visitorId, loadMessages]);

  useRealtime(publicKey, visitorId, () => {
    // See useRealtime.ts - no-op until the backend's real-time transport
    // is decided. Once it fires, this should append to the store the same
    // way sendMessage does.
  });

  return (
    <div className="flex h-full flex-col">
      <MessageList />
      <MessageInput externalCustomerId={visitorId} />
    </div>
  );
}
